import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-ocean-service-banner',
    templateUrl: './ocean-service-banner.component.html',
    styleUrls: ['./ocean-service-banner.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OceanServiceBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
